import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KeyboardModule } from '../../keyboard/keyboard.module';
import { FormTooltipModule } from '../form-tooltip/form-tooltip.module';
import { FormAutocompleteComponent } from './form-autocomplete.component';

/**
 * PRIVATE!
 *
 * Use {@link FormsModule}.
 */
@NgModule({
    imports: [
        CommonModule,
        OverlayModule,
        FormsModule,
        ReactiveFormsModule,
        FormTooltipModule,
        KeyboardModule,
    ],
    declarations: [FormAutocompleteComponent],
    exports: [FormAutocompleteComponent]
})
export class FormAutocompleteModule {
}
